import { global } from '../global';
import { paths, pathnames } from '../../paths';

export const error404 = {
  global,
  path: paths.error404,
  pathname: pathnames[paths.error404],
  content: {
    sections: [
      {
        type: '',
        elements: [
          {
            type: '',
            data: {

            }
          },
        ]
      },
    ]
  }
};
